export default "__VITE_ASSET__BPKYE2Qt__"